
export const ConstantsTamil = {
    patterns: [
        {
            //"search_word":"য়",
            //"replace_word":"y"
        },
        {
            //"search_word":"ড়",
            //"replace_word":"d"
        }
    ],
    //replacement while copying
    fix_patterns: [
        {
            "search_word":"য়",
            "replace_word":"য়"
        },
        {
            "search_word":"ড়",
            "replace_word":"ড়"
        },
        {
            "search_word":"ঢ়",
            "replace_word":"ঢ়"
        },
        {
            "search_word":"য়া",
            "replace_word":"য়া"
        },
        {
            "search_word":"ড়ো",
            "replace_word":"ড়ো"
        },
        {
            "search_word":"ঢ়ো",
            "replace_word":"ঢ়ো"
        },
        {
            "search_word":"ঢ়োঁ",
            "replace_word":"ঢ়োঁ"
        },
    ],
    variations:
    {
        // বিকল্প আখৰ আৰু শব্দৰ তালিকা।
        //"বিকল্পটো":"মূলটো" (মূলটো আছে, বিকল্পে ইটোও শুদ্ধ -এই কনচেপ্ট।// থকাটো যিকোনো এফালে //দিব লাগিব)
        
        "ভাড়া": "ভাৰা",

    }
}